import React from 'react';

import RolePermissionsSectionRow from 'roles/components/RolePermissionsSectionRow';

import { Form } from 'common/components';

const RolePermissionsSectionForm = ({
  handleCheckPermission,
  handleClickPermissionRow,
  handleCheckSection,
  permissions,
  section,
  t = (k) => k,
  values,
}) => {
  return (
    <div className="table-responsive mb-4">
      <h5 className="mb-3">{t(`${section}.title`)}</h5>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th width="5%">
              <Form.Checkbox
                className="icheckbox_flat-green"
                value={section}
                onChange={handleCheckSection}
              />
            </th>
            <th>{t('roles.permissions.description')}</th>
            <th width="20%">{t('roles.permissions.key')}</th>
          </tr>
        </thead>
        <tbody>
          {permissions.map((p) => (
            <RolePermissionsSectionRow
              key={p}
              handleCheckPermission={handleCheckPermission}
              handleClickPermissionRow={handleClickPermissionRow}
              permission={p}
              t={t}
              isChecked={values.indexOf(p) > -1}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RolePermissionsSectionForm;



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RolePermissionsSectionForm.js